import { BlueBirdTheme } from "@kitbird/core";
import styled from "styled-components";

const { primary } = BlueBirdTheme.colors;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  overflow: auto;
`;

export const FormGroup = styled.div<{ $justify?: string }>`
  display: flex;
  gap: 22px;
  justify-content: ${(p) => p.$justify || "space-between"};
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const FormWrapper = styled.div<{ $width?: string }>`
  width: ${(p) => p.$width || "100%"};

  /* remove scroll on dropdown */
  > div > div:nth-child(2) {
    overflow-y: auto;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  *:disabled {
    cursor: not-allowed !important;
  }

  .radio-group {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .grid-form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
  }
  

  .action-container {
    gap: 1rem;
    display: flex;
    justify-content: flex-end;
  }
`;
